import { render } from "./PasswordRegist.vue?vue&type=template&id=147052af&scoped=true"
import script from "./PasswordRegist.vue?vue&type=script&lang=js"
export * from "./PasswordRegist.vue?vue&type=script&lang=js"

import "./PasswordRegist.vue?vue&type=style&index=0&id=147052af&scoped=true&lang=css"

import exportComponent from "D:\\作業\\GitlabWebシステム\\ｱ_青森市社会福祉協議会_Webボランティアシステム\\Web-Volunteer-Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147052af"]])

export default __exports__